import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyTokensFromHash } from "./forge/suite/auth";
import { bootstrapTheme } from "./forge/themes/applyTheme";
import { bootstrapBgFx } from "./forge/themes/bgFx";
import "./index.css";
import "./forge/themes/bg-fx.css";

applyTokensFromHash();
bootstrapTheme();
bootstrapBgFx();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
